// oxlint-disable-next-line no-restricted-imports
import { createRoutePath } from "@myvp/shared/src/functions/create-route-path"

const embeddedLibrary = "/:vaultId/library-embedded"
const library = "/:vaultId/library"
const survey = `${library}/survey/:surveyId`

export const libraryManagerRouteNames = {
  embeddedStaticPage: createRoutePath("/:vaultId/static"),
  embeddedLibrary: createRoutePath(embeddedLibrary),
  standaloneLibrary: createRoutePath(library),
  survey: createRoutePath(survey),
  edit: createRoutePath(`${survey}/edit/:surveyTemplateId`),
  viewDetails: createRoutePath(`${survey}/view/:surveyTemplateId`),
  createSurvey: createRoutePath(`${library}/survey/create`),
  dynamicPreview: createRoutePath(`library/survey/preview`),
  globalPreview: createRoutePath(`/library/survey/preview/:surveyTemplateId`),
  terminalPage: createRoutePath(`${library}/survey/done`),
}
